var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"diff-check-switch"},[_c(_setup.AppSwitch,{attrs:{"value":_setup.diffCheckModel.status,"disabled":_setup.props.disabled},on:{"onHandler":_setup.toggleDiffCheck}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }